import { parseISO, format, parse } from "date-fns";

export default function Date({ dateString }) {
  const date = parseISO(dateString);

  return <time>{format(date, "LLLL dd, yyyy")}</time>;
}
